<template>
  <ul class="space-y-16 md:space-y-20">
    <li v-for="item in placeholderList" :key="item">
      <RevCard
        class="space-y-20 p-16 md:space-y-24"
        data-test="review-display-skeleton"
      >
        <div
          class="flex w-full flex-col items-start justify-between gap-12 md:flex-row"
        >
          <div class="w-full md:w-auto">
            <div
              class="flex items-center justify-between gap-8 md:justify-start"
            >
              <!-- Username skeleton -->
              <RevSkeleton class="h-24 w-96" />

              <!-- Verified badge skeleton -->
              <RevSkeleton class="rounded-xs h-20 w-96" />
            </div>

            <!-- Review info text skeleton -->
            <RevSkeleton class="mt-8 h-16 w-48" />
          </div>

          <!-- Rating skeleton -->
          <RevSkeleton class="h-20 w-96" />
        </div>

        <!-- Review text skeleton -->
        <div class="flex flex-col gap-8">
          <RevSkeleton class="h-16 w-full" />
          <RevSkeleton class="h-16 w-3/4" />
        </div>

        <!-- Product details skeleton -->
        <div class="flex flex-col gap-8">
          <RevSkeleton class="h-16 w-3/4" />
          <RevSkeleton class="h-16 w-1/2" />
        </div>
      </RevCard>
    </li>
  </ul>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { RevCard } from '@ds/components/Card'
import { RevSkeleton } from '@ds/components/Skeleton'

const props = defineProps<{ limit: number }>()

const placeholderList = computed(() => Array.from(Array(props.limit)))
</script>
